import { useMonarchRule } from "@/monarch/rules/MonarchRulesProvider";
import {
  HeroStatsRedesignTestData,
  UseHeroStatsRedesign,
  HeroStatsTestResult,
  HeroStatsRedesignVariants,
} from "./types";
import validateHex from "@/utils/functions/validateHex";
const CUSTOM_RULE_ID = "heroStatsVariant";

const useHeroStatsRedesign: UseHeroStatsRedesign = () => {
  const { isLoading, value } = useMonarchRule<{
    data: HeroStatsRedesignTestData;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading || !value) {
    return {
      isLoading,
    } as HeroStatsTestResult;
  }
  const variant: HeroStatsRedesignVariants = value.data.showNewDesign
    ? "test"
    : "control";

  return {
    isLoading: false,
    variant,
    data: {
      showUsNewsLogo: value?.data?.showUsNewsLogo ?? false,
      rankingText: value?.data?.rankingText ?? "",
      tuitionAndFees: value?.data?.tuitionAndFees ?? null,
      programType: value?.data?.programType ?? "",
      programDates: value?.data?.programDates ?? "",
      programDuration: value?.data?.programDuration ?? "",
      designVariant: value?.data?.designVariant ?? undefined,
      colorBarHexValue: value.data?.colorBarHexValue
        ? validateHex(value.data?.colorBarHexValue)
        : "",
      leadFormContext: value?.data?.leadFormContext ?? undefined,
    },
  };
};

export default useHeroStatsRedesign;
